import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ChevronDown, CheckCircle2 } from 'lucide-react';
import servicesBg from '../../Assest/cards/services.avif';

const GlassHeroSection = ({ scrollToForm, trustBadges }) => {
    // Animation Variants for entry
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15,
                delayChildren: 0.3
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const glassPaneVariants = {
        hidden: { opacity: 0, scale: 0.9, y: 30 },
        visible: { 
            opacity: 1, scale: 1, y: 0, 
            transition: { duration: 1, ease: "easeOut" } 
        }
    };

    return (
        <section className="relative h-fit flex items-center justify-center bg-[#01014C] overflow-hidden">
            
            {/* Full-screen background image */}
            <motion.div 
                initial={{ scale: 1.05, opacity: 0 }}
                animate={{ scale: 1, opacity: 0.5 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                className="absolute inset-0 w-full h-full object-cover pointer-events-none"
                style={{ 
                    backgroundImage: `url(${servicesBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundAttachment: 'fixed'
                }}
            />
            {/* Darker overlay to let the image show while keeping text readable */}
            <div className="absolute inset-0 bg-black/40 z-0 pointer-events-none" />

            <div className="container mx-auto px-6 relative z-10 py-20 flex flex-col justify-center min-h-full items-center text-center">
                
                {/* Static Text Container centered */}
                <motion.div 
                    variants={glassPaneVariants}
                    initial="hidden"
                    animate="visible"
                    className="relative w-full max-w-4xl p-4 my-auto"
                >
                    {/* Content */}
                    <motion.div 
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                        className="flex flex-col items-center"
                    >
                        <motion.span 
                            variants={itemVariants}
                            className="inline-block text-blue-400 font-bold tracking-widest text-xs uppercase mb-6"
                        >
                            Enterprise-Grade HR Consulting
                        </motion.span>

                        <motion.h1 
                            variants={itemVariants}
                            className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white leading-tight syne mb-6 drop-shadow-lg"
                        >
                            AI-Powered <br/>
                            <span className="text-blue-400">
                                HR Consulting Services
                            </span>
                        </motion.h1>

                        <motion.p 
                            variants={itemVariants}
                            className="text-slate-200 text-sm md:text-base leading-relaxed mb-10 font-medium tracking-wide max-w-2xl" 
                            style={{ textShadow: "0px 1px 2px rgba(0,0,0,0.8)" }}
                        >
                            We help businesses streamline hiring, payroll, compliance, and recruitment operations through specialized systems built for modern growth.
                        </motion.p>

                        <motion.div 
                            variants={itemVariants}
                            className="flex flex-col sm:flex-row gap-4" 
                        >
                            <button 
                                className="px-8 py-2 bg-blue-600 hover:bg-blue-500 text-white font-bold rounded-full transition-all duration-300 flex items-center justify-center gap-2 shadow-[0_10px_20px_rgba(37,99,235,0.4)] hover:shadow-[0_10px_30px_rgba(37,99,235,0.6)] hover:-translate-y-1"
                                onClick={scrollToForm}
                            >
                                Get Free Consultation <ArrowRight size={18} />
                            </button>
                            <button
                                className="px-8 py-2 border border-white/30 hover:border-white text-white font-bold rounded-full transition-all duration-300 flex items-center justify-center gap-2 backdrop-blur-sm hover:bg-white/10 hover:-translate-y-1"
                                onClick={() => {
                                    const el = document.getElementById('services-section');
                                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                                }}
                            >
                                Explore HR Services <ChevronDown size={18} />
                            </button>
                        </motion.div>
                    </motion.div>
                </motion.div>

                {/* HERO TRUST STRIP */}
                {/* <motion.div 
                    initial="hidden"
                    animate="visible"
                    variants={{
                        hidden: { opacity: 0 },
                        visible: {
                            opacity: 1,
                            transition: { staggerChildren: 0.1, delayChildren: 1 }
                        }
                    }}
                    className="mt-16 w-full max-w-6xl"
                >
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                        {trustBadges.map((badge, idx) => (
                            <motion.div
                                key={idx}
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 100 } }
                                }}
                                className="p-4 py-2 rounded-2xl bg-white/5 border border-white/10 flex flex-col justify-center items-center text-center transition-all duration-300 hover:border-blue-400/30 hover:bg-white/10 backdrop-blur-sm group"
                            >
                                <motion.div whileHover={{ scale: 1.2, rotate: 10 }} transition={{ type: "spring", stiffness: 300 }}>
                                    <CheckCircle2 size={18} className="text-blue-400 mb-2 group-hover:text-cyan-300 transition-colors" />
                                </motion.div>
                                <span className="text-xs font-bold text-slate-300 tracking-wide leading-snug">{badge}</span>
                            </motion.div>
                        ))}
                    </div>
                </motion.div> */}

            </div>
        </section>
    );
};

export default GlassHeroSection;
